export const cannedContentTypes = Object.freeze({
    CANNED_EMAIL: "CANNED_EMAIL",
    CANNED_RESPONSE: "CANNED_RESPONSE",
});

export const cannedContentDropdownActions = Object.freeze({
    EDIT: "EDIT",
    DELETE: "DELETE",
});
